/**
 * PayItem - Represents a pay item in a construction contract specification.
 * Pay items are used for billing and quantity tracking in construction projects.
 */
export class PayItem {
  /** Reference item name/identifier */
  REFITEM_NM: string;

  /** Specification book number */
  SpecBook: number;

  /** Classification number */
  Class: number;

  /** Type classification */
  Type: string;

  /** Item number */
  Item: number;

  /** Description of the pay item */
  Description: string;

  /** Unit of measurement */
  Unit: string;

  /** Unit plan identifier */
  UnitPlan: string;

  /** Indicates if this is a plan quantity item */
  IsPlanQty: boolean;

  /**
   * Creates a new PayItem instance
   * @param data - Object containing pay item properties
   */
  constructor(data: {
    REFITEM_NM: string;
    SpecBook: number;
    Class: number;
    Type: string;
    Item: number;
    Description: string;
    Unit: string;
    UnitPlan: string;
    IsPlanQty: boolean;
  }) {
    this.REFITEM_NM = data.REFITEM_NM;
    this.SpecBook = data.SpecBook;
    this.Class = data.Class;
    this.Type = data.Type;
    this.Item = data.Item;
    this.Description = data.Description;
    this.Unit = data.Unit;
    this.UnitPlan = data.UnitPlan;
    this.IsPlanQty = data.IsPlanQty;
  }

  /**
   * Creates a PayItem from a plain object (useful for deserialization)
   * @param obj - Plain object with pay item data
   * @returns New PayItem instance
   */
  static fromObject(obj: Partial<PayItem>): PayItem {
    return new PayItem({
      REFITEM_NM: obj.REFITEM_NM ?? "",
      SpecBook: obj.SpecBook ?? 0,
      Class: obj.Class ?? 0,
      Type: obj.Type ?? "",
      Item: obj.Item ?? 0,
      Description: obj.Description ?? "",
      Unit: obj.Unit ?? "",
      UnitPlan: obj.UnitPlan ?? "",
      IsPlanQty: obj.IsPlanQty ?? false,
    });
  }

  /**
   * Converts the PayItem to a plain object (useful for serialization)
   * @returns Plain object representation
   */
  toObject(): Record<string, unknown> {
    return {
      REFITEM_NM: this.REFITEM_NM,
      SpecBook: this.SpecBook,
      Class: this.Class,
      Type: this.Type,
      Item: this.Item,
      Description: this.Description,
      Unit: this.Unit,
      UnitPlan: this.UnitPlan,
      IsPlanQty: this.IsPlanQty,
    };
  }
}


